import Vue from 'vue'
import { usrActions, usrGetters } from '@/stores/user.module'

Object.defineProperty(Vue.prototype, '$user', { value: { usrGetters, usrActions } })
